import { FC, useState } from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { Box, FormHelperText, useTheme } from '@mui/material';
import { StripeCardElementChangeEvent } from '@stripe/stripe-js';
import { PAYMENT_ERRORS } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';

interface IProps {
	error?: string;
	setValid: (value: boolean) => void;
	clearError?: () => void;
}

const StripePayment: FC<IProps> = ({ error, setValid, clearError }) => {
	const theme = useTheme();
	const [vendorError, setVendorError] = useState<string | undefined>();

	const handleChange = (event: StripeCardElementChangeEvent) => {
		if (vendorError || !event.error || error) {
			if (clearError) {
				clearError();
			}
			setVendorError(undefined);
		}
		if (event.error?.message) {
			setVendorError(event.error.message);
			setValid(false);
			return;
		}
		if (!event.brand.includes('visa') && !event.brand.includes('mastercard') && !event.empty) {
			setVendorError(PAYMENT_ERRORS.vendorType);
			setValid(false);
			return;
		}

		if (!event.empty && event.complete && !event.error) {
			setVendorError(undefined);
			setValid(true);
		}
	};

	return (
		<Box>
			<Box
				sx={{
					py: 2,
					px: 1,
					backgroundColor: '#f8f4fc',
					border: `2px solid ${error || vendorError ? theme.palette.error.main : theme.palette.primary.main}`,
					borderRadius: 2,
				}}
			>
				<CardElement
					options={{
						style: {
							base: {
								fontSize: '20px',
								backgroundColor: '#f8f4fc',
								color: error || vendorError ? theme.palette.error.main : theme.palette.primary.main,
								'::placeholder': {
									color: '#aaaaaa',
								},
							},
							invalid: {
								color: theme.palette.error.main,
							},
						},
						hidePostalCode: true,
					}}
					onChange={handleChange}
				/>
			</Box>
			{(vendorError || error) && <FormHelperText error>{vendorError || error}</FormHelperText>}
		</Box>
	);
};

export default StripePayment;
